import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Grid2, Stack } from "@mui/material";

import {
  getCurrentDateTime,
  transformWidgetTableData,
} from "../../../utils/helpers";

import { Button } from "../../ui/Button/Button";
import { ButtonCopy } from "../../ui/ButtonCopy/ButtonCopy";
import { WidgetRow } from "../WidgetRow/WidgetRow";
import { addStyles } from "./addStyles";
import { useTranslateData } from "./data";

import { BoxWrapper } from "../../box-wrapper/BoxWrapper.styled";
import {
  GridContainer,
  GridItem,
  Text,
  Title,
  Wrapper,
} from "./WidgetTable.styled";

export const WidgetTable = ({
  button,
  params = "all",
  children,
  type,
  onButtonClick,
  backData,
}) => {
  const [currentTime, setCurrentTime] = useState("");
  const { t } = useTranslation();

  let data = useTranslateData();

  if (backData) {
    data = transformWidgetTableData(data, backData);
  }

  useEffect(() => {
    if (backData?.ip) {
      setCurrentTime(getCurrentDateTime());
    }
  }, [backData]);

  const getUserParams = () => {
    if (params === "all") {
      return data;
    }

    if (params === "none") {
      return [];
    }

    return data?.filter(deviceParam => params.includes(deviceParam.id));
  };

  const countryCode = useCallback(
    () => data.find(({ id }) => id === "countryCode")?.value,
    [data],
  );

  return (
    <BoxWrapper addStyles={addStyles.wrapper(type, button)}>
      <Wrapper>
        <GridContainer container>
          <GridItem>
            <Title>
              {t("widgetTable.title")}{" "}
              {backData?.ip ? backData.ip : t("global.loading")}
            </Title>

            <ButtonCopy addStyles={addStyles.buttonCopy} text={backData?.ip} />
          </GridItem>

          <Grid2>
            <Text>
              {t("widgetTable.securityReport")}{" "}
              {backData?.ip ? currentTime : t("global.loading")}
            </Text>
          </Grid2>
        </GridContainer>

        <Stack direction="column" spacing={2}>
          {getUserParams()?.map((item, i) => (
            <WidgetRow key={i} item={item} code={countryCode()} />
          ))}
          {children}
        </Stack>
      </Wrapper>

      {button && (
        <Button styles={addStyles.button} onClick={onButtonClick}>
          {button}
        </Button>
      )}
    </BoxWrapper>
  );
};
